import * as React from 'react';

const Saved = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M14 5H2V19L8 15L14 19V5Z" fill="currentColor" />
    </svg>
);

export default Saved;
